/**
* DialogPlayerOptionsFixedButtonsMediator.js
* 
* Created on 8-okt-2013, 15:34:40
*
* @author Ivo Swartjes for Ranj
**/

import Button from "/lib/html5-software-library/src/ranj/components/buttons/Button";
import DialogOptionButton from "/lib/html5-software-library/src/ranj/components/buttons/DialogOptionButton";
import ContentTypes from "/lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import QuizAnswerContent from "/lib/html5-software-library/src/ranj/eng/content/QuizAnswerContent";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";
import SoundType from "../../../core/sound/util/SoundType";
import NGTDialogPlayerEvent from "../NGTDialogPlayerEvent";
import AbstractDialogPlayerOptionsMediator from "./AbstractDialogPlayerOptionsMediator";
import DialogOptionHelper from "./DialogOptionHelper";
import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import NGTVariableManager from "../../base/NGTVariableManager";
import ScreenNavigator from "../../../../../lib/html5-software-library/src/ranj/ui/ScreenNavigator";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";

export default class DialogPlayerOptionsAndTopicsFixedButtonsMediator extends AbstractDialogPlayerOptionsMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {SoundManager} soundManager 
     * @param {NGTVariableManager} variableManager 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ScreenNavigator} screenNavigator 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     */
    constructor(target, soundManager, variableManager, dispatcher, screenNavigator, layoutManager, clickEaterFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._skin = target;
        this._topicsSkin = this._skin["topicSelectionButtonPanel"];
        this._answersSkin = this._skin["dialogAnswerButtonPanel"];
        this._answerTimer = this._skin.dialogAnswerButtonPanel["answerTimer"];
        this._variableManager = variableManager;
        //MouseEventLogger.addMouseEventLogging(this._skin, "DIALOG OPTIONS PANEL");

        this._optionButtonDict = {};
        this._buttonArrayAnswers = [];
        this._buttonArrayTopics = [];
        this._backButtonSkin = this._answersSkin.backButton;
        this._endButtonSkin = this._topicsSkin.endButton;
        this._backButton;
        this._endButton;
        this._soundManager = soundManager;
        this.dispatcher = dispatcher;
        this._screenNavigator = screenNavigator;

        this._onDialogAnswerTimerBound = this._onDialogAnswerTimer.bind(this);
    }

    initialize() {
        super.initialize();

        this._topicsSkin.visible = false;
        this._answersSkin.visible = false;
        this._answerTimer.visible = false;

        this._handleOptionButtonClickBound = this._onOptionButtonClicked.bind(this);

        //this._skin.gotoAndStop(0);

        for (let i = 1; i <= DialogPlayerOptionsAndTopicsFixedButtonsMediator.NUM_ANSWER_BUTTONS; i++) {
            var buttonSkin = this._answersSkin[`dialogOptionButton${i}`];

            var button = new DialogOptionButton(buttonSkin);
            //MouseEventLogger.addMouseEventLogging(button.skin, "button " + i);
            this._buttonArrayAnswers.push(button);
        }

        for (let j = 1; j <= DialogPlayerOptionsAndTopicsFixedButtonsMediator.NUM_TOPIC_BUTTONS; j++) {
            var buttonSkin = this._topicsSkin[`topicsOptionButton${j}`];

            var button = new DialogOptionButton(buttonSkin);
            //MouseEventLogger.addMouseEventLogging(button.skin, "button " + i);
            this._buttonArrayTopics.push(button);
        }

        this._backButton = new Button(this._backButtonSkin);
        this._endButton = new Button(this._endButtonSkin);

        this._clearOptionButtons();

        this.setDialogPlayer(this._skin["dialogPlayer"]);

        //this._soundManager = new SoundManager();

    }

    destroy() {
        super.destroy();

        this._optionButtonDict = null;
        this._screenNavigator = null;
    }

    _addDialogPlayerListeners() {
        super._addDialogPlayerListeners();

        this._dialogPlayer.eventDispatcher.addEventListener(NGTDialogPlayerEvent.ANSWER_TIMER, this._onDialogAnswerTimerBound);
    }

    _onQuizTimeOut() {
        if (this.quizTimerSound)
            this._soundManager.stopSound(this.quizTimerSound);

        this.quizTimerSound = 0;
    }

    _removeDialogPlayerListeners() {
        super._removeDialogPlayerListeners();
        //JE TODO: this._dialogPlayer is null
        //this._dialogPlayer.eventDispatcher.removeEventListener(NGTDialogPlayerEvent.ANSWER_TIMER, this._onDialogAnswerTimerBound);
    }

    // ------------------------------------------
    // 			Dialog displaying
    // ------------------------------------------

    _onOptionButtonClicked({ currentTarget }) {
        const option = this._optionButtonDict[currentTarget.skin.id];

        // Find option button
        const button = this._findButtonForSkin(currentTarget.skin);
        if (!isNull(button)) {
            button.setSelected(true);
        };

        //unbind the click
        for (let i = 0; i < this._buttonArrayAnswers.length; i++) {
            this._buttonArrayAnswers[i].removeEventListener("click", this._handleOptionButtonClickBound);
            this._buttonArrayTopics[i].removeEventListener("click", this._handleOptionButtonClickBound);
        }


        const onCompleteFunction = function (option) {
            this.getDialogPlayer().optionChosen(option);
        };

        if (option.getData().getData().content.getType() === QuizAnswerContent.TYPE) {
            button.skin.correction.visible = true;
            const correct = option.getData().getData().content.getIsCorrectAnswer();
            if (this.quizTimerSound)
                this._soundManager.stopSound(this.quizTimerSound);
            this.quizTimerSound = 0;
            this._soundManager.playSound(correct ? SoundType.SOUND_CORRECT_ANSER : SoundType.SOUND_INCORRECT_ANSWER);

            button.skin.correction.gotoAndStop(correct ? "correct" : "incorrect");
            for (const opt in this._optionButtonDict) {
                if (!correct) {
                    if (this._optionButtonDict[opt].getData().getData().content.getIsCorrectAnswer()) {
                        const btn = this._findButtonOfOption(opt);
                        btn.skin.correction.visible = true;
                        btn.skin.correction.gotoAndStop("correct");
                    }
                }
                this._findButtonOfOption(opt).setEnabled(false);
            }

            //show correct answer 2 sec before animating out
            setTimeout(() => {
                this._animateOut(onCompleteFunction.bind(this), [option]);
                this._dialogPlayer.setPaused(false);
                //if(correct)
                //this._soundManager.playSound(SoundType.SOUND_DAFKNOWLEDGE_INCREASE);
            }, 2000);

            // pause the dialogplayer timer
            this._dialogPlayer.setPaused(true);
        } else {
            this._soundManager.playSound(SoundType.BUTTON_CLICK);
            // Animate out, then tell delegate that this option was chosen.        
            this._animateOut(onCompleteFunction.bind(this), [option]);
        }
    }

    _findButtonOfOption(opt) {
        for (let i = 0; i < this._buttonArrayAnswers.length; i++) {
            if (this._buttonArrayAnswers[i].skin.id === parseInt(opt))
                return this._buttonArrayAnswers[i];
        }
    }

    _onDialogAnswerTimer({ params }) {
        //console.log("ON DIALOG ANSWER TIMER");



        const timePct = params.data.passed / (params.data.passed + params.data.remaining);
        this._answerTimer.visible = true;
        if (timePct >= 0 && timePct <= 1) {
            this._answerTimer.gotoAndStop(Math.round(timePct * 50));
        }

        //Quick 'n dirty fix for bug as detailed here: https://www.ranjnet.nl/bugs/view.php?id=8117
        //TODO: Listen to event that gets called when timer runs out and clear audio there.
        if (params.data.remaining < 150)
            this._onQuizTimeOut();
    }

    _clearOptionButtons() {
        /*if (this.quizTimerSound)
            this._soundManager.stopSound(this.quizTimerSound);
        this.quizTimerSound = 0;*/

        for (var i = 0; i < DialogPlayerOptionsAndTopicsFixedButtonsMediator.NUM_ANSWER_BUTTONS; i++) {
            var button = this._buttonArrayAnswers[i];
            button.removeEventListener("click", this._handleOptionButtonClickBound);
            button.setSelected(false);
            button.skin.visible = false;
            delete this._optionButtonDict[button.skin.id];
        }

        for (var i = 0; i < DialogPlayerOptionsAndTopicsFixedButtonsMediator.NUM_TOPIC_BUTTONS; i++) {
            var button = this._buttonArrayTopics[i];
            button.removeEventListener("click", this._handleOptionButtonClickBound);
            button.setSelected(false);
            button.skin.visible = false;
            delete this._optionButtonDict[button.skin.id];
        }
    }

    _shuffleArray(arrayUnshuffled) {
        const arrayShuffled = [];
        while (arrayUnshuffled.length > 0) {
            const rndIdx = Math.round(Math.random() * (arrayUnshuffled.length - 1));
            arrayShuffled.push(arrayUnshuffled[rndIdx]);
            arrayUnshuffled.remove(arrayUnshuffled[rndIdx]);
        }

        return arrayShuffled;
    }

    _findButtonForSkin(skin) {
        let curButton;
        if (!isNull(this._buttonArrayAnswers)) {
            for (let i = 0; i < this._buttonArrayAnswers.length; i++) {
                curButton = this._buttonArrayAnswers[i];
                if (curButton.skin === skin) return curButton;
            }
        }

        if (!isNull(this._buttonArrayTopics)) {
            for (let j = 0; j < this._buttonArrayTopics.length; j++) {
                curButton = this._buttonArrayTopics[j];
                if (curButton.skin === skin) return curButton;
            }
        }
        return null;
    }

    _handleDialogOptionsChanged() {

        this._answerTimer.visible = false;

        // Clear & hide all dialog buttons
        this._clearOptionButtons();

        this._topicsSkin.visible = false;
        this._answersSkin.visible = false;
        this._backButton.skin.visible = false;
        this._endButton.skin.visible = false;
        let topicsPresent = false;
        let answersPresent = false;
        let playQuizTimer = false;

        // Show relevant dialog buttons
        const currentOptions = this.getDialogPlayer().getCurrentOptions();
        let backOption;
        let endOption;

        // Shuffle
        let doShuffle = true;
        const currentOptionsUnshuffled = currentOptions.clone();
        for (var i = currentOptionsUnshuffled.length - 1; i >= 0; i--) {
            // Filter out "special" options
            if (DialogOptionHelper.isContinueOption(currentOptionsUnshuffled[i])) {
                // Continue option is handled by the dialog player mediator
                currentOptionsUnshuffled.remove(currentOptionsUnshuffled[i]);
            }
            else if (DialogOptionHelper.isBackOption(currentOptionsUnshuffled[i])) {
                // BACK option
                backOption = currentOptionsUnshuffled[i];

                var btn = this._backButton;
                btn.skin.visible = true;
                btn.addEventListener("click", this._handleOptionButtonClickBound);
                this._optionButtonDict[btn.skin.id] = backOption;

                currentOptionsUnshuffled.remove(backOption);
            }
            else if (DialogOptionHelper.isEndOption(currentOptionsUnshuffled[i])) {
                // END option
                endOption = currentOptionsUnshuffled[i];

                var btn = this._endButton;
                btn.skin.visible = true;
                btn.addEventListener("click", this._handleOptionButtonClickBound);
                this._optionButtonDict[btn.skin.id] = endOption;

                currentOptionsUnshuffled.remove(endOption);
            } else if (DialogOptionHelper.isConversationTopicOption(currentOptionsUnshuffled[i])) {
                // Do not shuffle conversation topics.
                doShuffle = false;
            }
        };

        let currentOptionsShuffled;
        if (DialogPlayerOptionsAndTopicsFixedButtonsMediator.SHUFFLE_OPTIONS && doShuffle) {
            currentOptionsShuffled = this._shuffleArray(currentOptionsUnshuffled);
        } else {
            currentOptionsShuffled = currentOptionsUnshuffled;
        }

        let textOptionCounter = 0;
        for (var i = 0; i < currentOptionsShuffled.length; i++) {
            const option = currentOptionsShuffled[i];
            var btn;

            let dialogContentPackage = null;
            if (!isNull(option.getData())) {
                dialogContentPackage = option.getData().getData();
            }
            if (!isNull(dialogContentPackage)) {
                const content = dialogContentPackage.content;
                if (content !== null) {

                    var btn;
                    let label;

                    if (content.getType() === ContentTypes.TYPE_CONVERSATION_TOPIC) {
                        btn = this._buttonArrayTopics[i];
                        topicsPresent = true;
                    } else {
                        btn = this._buttonArrayAnswers[textOptionCounter];
                        btn.skin.correction.visible = false;
                        btn.setTitle(String.fromCharCode(textOptionCounter + 65));
                        answersPresent = true;
                        textOptionCounter++;
                    }

                    this._optionButtonDict[btn.skin.id] = option;
                    btn.setEnabled(true);

                    if (content.getType() === ContentTypes.TYPE_TEXT) {
                        label = content.getText();

                    } else if (content.getType() === ContentTypes.TYPE_QUIZANSWER) {
                        label = content.getAnswerText();

                        playQuizTimer = true;

                    } else if (content.getType() === ContentTypes.TYPE_KEY_MOMENT_CHOICE) {
                        label = content.getChoice();

                    } else if (content.getType() === ContentTypes.TYPE_CONVERSATION_TOPIC) {

                        label = content.getTopicDescription();

                        if (this._isConversationTopicNew(content)) {
                            btn.skin.newIndicator.visible = true;
                        } else {
                            btn.skin.newIndicator.visible = false;
                        }

                        if (this._isConversationTopicExhausted(content)) {
                            btn.setEnabled(false);
                        } else {
                            btn.setEnabled(true);
                        }
                    }

                    if (label === null || label === "") label = "<TEXT NOT FOUND>";
                    btn.setCenteredLabel(label);
                }
            }

            if (topicsPresent) this._topicsSkin.visible = true;
            if (answersPresent) this._answersSkin.visible = true;

            if (playQuizTimer && !this.quizTimerSound)
                this.quizTimerSound = this._soundManager.playSound(SoundType.SOUND_QUIZ_TIMER);

            btn.skin.visible = true;
            btn.addEventListener("click", this._handleOptionButtonClickBound);
        }

        if (currentOptionsShuffled.length > 0) { // && ! this._isContinueOption(currentOptionsShuffled[0])) {
            this._animateIn();

            //this._skin.gotoAndPlay("animIn");
        } else {
            this._animateOut();
        }
    }

    _handleDialogOptionChosen() {
        //this._skin.gotoAndPlay("animOut");       
        //this._animateOut();        
    }

    _isConversationTopicNew(conversationTopicContent) {
        const topicNewCondition = conversationTopicContent.getTopicNewCondition();
        if (!isNull(topicNewCondition)) {
            return this._variableManager.solveExpression(topicNewCondition);
        } else {
            return false;
        }
    }

    _isConversationTopicExhausted(conversationTopicContent) {
        const topicExhaustedCondition = conversationTopicContent.getTopicDisabledCondition();
        if (!isNull(topicExhaustedCondition)) {
            return this._variableManager.solveExpression(topicExhaustedCondition);
        } else {
            return false;
        }
    }

    /*
     * Checks in how many rows the buttons are arranged, each different y value is another row
     * @param {array of Button} buttonArray - An array of Button's
     * @returns {integer} - The amount of rows the buttons are in
     */
    _getAmountOfButtonRows(buttonArray) {
        if (buttonArray.length === 0)
            return 0;

        let rows = 1;
        let buttonY = buttonArray[0].skin.y;
        for (let i = 1; i < buttonArray.length; i++) {
            if (buttonArray[i].skin.y !== buttonY) {
                buttonY = buttonArray[i].skin.y;
                rows++;
            }
        }

        return rows;
    }

    /*
     * Gets the visible buttons in an array of buttons
     * Precondition: The array of buttons is sorted from visible to invisible
     * @param {array of Button} buttonArray - An array of Button's
     * @returns {array of Button} - An array of visible buttons
     */
    _getAvailableButtons(buttonArray) {
        const availableButtons = [];
        for (let i = 0; i < buttonArray.length; i++) {
            if (!buttonArray[i].skin.visible)
                break;
            availableButtons.push(buttonArray[i]);
        }
        return availableButtons;
    }

    _animateIn(onComplete, onCompleteParams) {
        createjs.Tween.removeTweens(this._skin);

        const onTweenComplete = function () {
            if (!isNull(onComplete)) {
                onComplete.apply(null, onCompleteParams);
            }
        }
        createjs.Tween.get(this._skin).to({ alpha: 1 }, 350, createjs.Ease.sineInOut).call(onTweenComplete);
    }

    _animateOut(onComplete, onCompleteParams) {
        createjs.Tween.removeTweens(this._skin);

        const onTweenComplete = function () {
            if (!isNull(onComplete)) {
                onComplete.apply(null, onCompleteParams);
            }
        }
        createjs.Tween.get(this._skin).to({ alpha: 0 }, 350, createjs.Ease.sineInOut).call(onTweenComplete);
    }
}

DialogPlayerOptionsAndTopicsFixedButtonsMediator.NUM_TOPIC_BUTTONS = 8;
DialogPlayerOptionsAndTopicsFixedButtonsMediator.NUM_ANSWER_BUTTONS = 4;
DialogPlayerOptionsAndTopicsFixedButtonsMediator.SHUFFLE_OPTIONS = false;